import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Alert, Snackbar } from '@mui/material';
import {
  $errorRelated,
  $successRelatedDelete,
  $successRelatedSave,
  clearError,
  resetSuccessRelatedDelete,
  resetSuccessRelatedSave,
} from '../../../models/related-tickets';

export const SnackAlerts = () => {
  const { t } = useTranslation();
  const [errorRelated, successRelatedSave, successRelatedDelete] = useUnit([
    $errorRelated,
    $successRelatedSave,
    $successRelatedDelete,
  ]);

  if (errorRelated) {
    return (
      <Snackbar
        open
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={5000}
        onClose={() => clearError()}
      >
        <Alert severity="error" variant="filled">
          {errorRelated.message}
        </Alert>
      </Snackbar>
    );
  }

  if (successRelatedSave) {
    return (
      <Snackbar
        open
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={5000}
        onClose={() => resetSuccessRelatedSave()}
      >
        <Alert severity="success" variant="filled">
          {t('LinkHasBeenCreated')}
        </Alert>
      </Snackbar>
    );
  }

  if (successRelatedDelete) {
    return (
      <Snackbar
        open
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={5000}
        onClose={() => resetSuccessRelatedDelete()}
      >
        <Alert severity="success" variant="filled">
          {t('LinkHasBeenRemoved')}
        </Alert>
      </Snackbar>
    );
  }

  return null;
};
